module.exports = __webpack_public_path__ + "index/img/contact2.a6f3e1df.png";